import { createAsyncThunk } from '@reduxjs/toolkit';
import submissionService from 'api/submissionService';
import obligationService from 'api/obligationService';
import messageService from 'api/messageService';
import { notifyApiError } from 'api/apiUtils';
import { notifyError, notifySuccess } from 'utils/notifications';
import institutionService from 'api/institutionService';

export const getSubmission = createAsyncThunk(
  'submissionDetail/getSubmission',
  async (submissionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.getSubmission(submissionId);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const getObligationXsd = createAsyncThunk(
  'submissionDetail/getObligationXsd',
  async ({ obligationId, fileName }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const blob = await obligationService.getObligationXsd(obligationId);
      const fs = await import('file-saver');
      fs.saveAs(blob, `${fileName}.xsd`);
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const uploadFileDetailView = createAsyncThunk(
  'submissionDetail/uploadFileDetailView',
  async ({ submissionId, payload }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.uploadSubmissionFile(
        submissionId,
        payload
      );
      if (response === 'OK') {
        notifySuccess(
          i18n.t('datagate.external.submissions.message.uploadSuccess')
        );
        return response;
      } else if (response === 'VIRUS_FOUND') {
        notifyError(i18n.t('datagate.external.upload.error.virusFound'));
        return rejectWithValue(response);
      } else {
        notifyError(i18n.t('datagate.external.upload.error.unknown'));
        return rejectWithValue(response);
      }
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const followSubmission = createAsyncThunk(
  'submissionDetail/followSubmission',
  async (submissionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.followSubmission(submissionId);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const unfollowSubmission = createAsyncThunk(
  'submissionDetail/unfollowSubmission',
  async (submissionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.unfollowSubmission(submissionId);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const sendMessage = createAsyncThunk(
  'submissionDetail/sendMessage',
  async (data, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await messageService.createMessage(data);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const changeObligationReporter = createAsyncThunk(
  'submissionDetail/changeObligationReporter',
  async ({ obligationId, user }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await obligationService.changeObligationReporter(
        obligationId,
        user
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const getReporters = createAsyncThunk(
  'submissionDetail/getReporters',
  async (institutionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.getInstitutionUsers(
        institutionId
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const addFollowers = createAsyncThunk(
    'submissionDetail/addFollowers',
    async ({ submissionId, followerIds }, { rejectWithValue, extra: { i18n } }) => {
        try {
            const response = await submissionService.addFollowers(submissionId, followerIds);
            return response;
        } catch (error) {
            notifyApiError(i18n, error);
            return rejectWithValue(error);
        }
    }
);

export const getExternalFollowers = createAsyncThunk(
    'submissionDetail/externalfollowers',
    async ({ submissionId }, { rejectWithValue, extra: { i18n } }) => {
        try {
            const response = await submissionService.getExternalFollowers(submissionId);
            return response;
        } catch (error) {
            notifyApiError(i18n, error);
            return rejectWithValue(error);
        }
    }
);

